import src from "IMAGE";
export default { src, width: 394, height: 80, blurWidth: 0, blurHeight: 0};
